
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Switch from '@/components/switch.vue';
	import Message from '@/components/message.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    activityPayGiftactivityPayGiftPageInit,
    activityPayGiftactivityPayGiftIsOpenEdit,
    activityExchangeBuyactivityExchangeBuyDelete,

    activityExchangeBuyactivityExchangeBuyPageInit,
    activityExchangeBuyactivityExchangeBuyIsOpenUpdate,
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-switch': Switch,
			'slz-message': Message,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private state = null
    private statelist = [
      {value:null,label:'全部'},
      {value:0,label:'未开始'},
      {value:1,label:'进行中'},
      {value:2,label:'已结束'},
    ]
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private total = 0
    private pageSize = 10
    private pageNo = 1
    private rowmsg:any = {}
    private delShow = false
    private showcode = false
    private codemsg:any = {}

    private mounted () {
      this.gettablelist()
    }

    private todata(row){
      this.$router.push({
        name:'tradeInActivityData',
        query:{
          Id:row.Id,
          Name:encodeURIComponent(row.Name),
          Type:row.EquityType
        }
      })
    }
    private async confirmdel(){
      try{
        this.tableloading = true
        let res:any = await activityExchangeBuyactivityExchangeBuyDelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.delShow = false
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private todel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private async changeState(e,row){
      try{
        this.tableloading = true
        let res:any = await activityExchangeBuyactivityExchangeBuyIsOpenUpdate({
          Id:row.Id,
          IsOpen:e
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await activityExchangeBuyactivityExchangeBuyPageInit({
          Keywords:this.keywords,
          State:this.state,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.changePage(1)
    }
    private clearSearch(){
      this.state = null
      this.keywords = ''
      this.changePage(1)
    }
    private todetails(row){
      this.$router.push({
        name:'tradeInActivityDetails',
        query:{
          Id:row.Id,
        }
      })
    }
  }
